import { useQuery } from "@tanstack/react-query";
import { PurchasePlan } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleGetHprPurchasePlans } from "../../api-clients/walletsPlansClient";
import useAuth from "../../hooks/useAuth";
import { BONUS_PERCENT_MARKER } from "../../utils/constants";

const WELCOME_PROMO_MARKER = "specialOffer";

const checkHasWelcomeBonus = (plan: PurchasePlan): boolean =>
  plan.metadata !== undefined &&
  plan.metadata.length > 0 &&
  plan.metadata.map((e) => e.name).includes(WELCOME_PROMO_MARKER);

function useHprPurchasePlansQuery() {
  const { isLoggedIn } = useAuth();

  const { data: purchasePlansList } = useQuery({
    queryKey: [QUERY_KEYS.WALLET.PURCHASE_PLANS],
    queryFn: handleGetHprPurchasePlans,
    enabled: isLoggedIn,
  });

  const specialOfferPlans =
    purchasePlansList?.records.filter(checkHasWelcomeBonus);

  const welcomeBonusPercentages = specialOfferPlans
    ?.map((plan) =>
      Number(
        plan.metadata?.find((item) => item.name === BONUS_PERCENT_MARKER)?.value
      )
    )
    .filter((percent) => Number.isFinite(percent) && percent > 0);

  return {
    allPurchasePlans: purchasePlansList?.records,
    specialOfferPlans,
    hasWelcomeBonus: !!specialOfferPlans?.length,
    welcomeBonusPercent: welcomeBonusPercentages?.length
      ? Math.max(...welcomeBonusPercentages)
      : undefined,
  };
}

export default useHprPurchasePlansQuery;
